import * as THREE from 'three'

const box_width = 4
const box_length = 6
const chalk_width = 1 / 4 // 3 inches estimated?

const zone_depth = 0.05
const extrude_settings = {
    depth: zone_depth,
    bevelEnabled: false,
    // bevelSegments: 2,
    steps: 2,
    // bevelSize: 0.1,
    // bevelThickness: 1,
}

// batters box
const batters_box_shape = new THREE.Shape()
    .moveTo(0, 0)
    .lineTo(box_width, 0)
    .lineTo(box_width, box_length)
    .lineTo(0, box_length)
    .lineTo(0, 0)

const batters_box_hole = new THREE.Path()
    .moveTo(chalk_width, chalk_width)
    .lineTo(box_width - chalk_width, chalk_width)
    .lineTo(box_width - chalk_width, box_length - chalk_width)
    .lineTo(chalk_width, box_length - chalk_width)
    .lineTo(chalk_width, chalk_width)

batters_box_shape.holes.push(batters_box_hole)
const batters_box_geometry = new THREE.ExtrudeGeometry(
    batters_box_shape,
    extrude_settings
)

export default class BattersBox {
    constructor() {
        this.group = new THREE.Group()
        this.group.name = 'batters-box'

        const lhb_batters_box_mesh = new THREE.Mesh(
            batters_box_geometry,
            new THREE.MeshBasicMaterial({ color: 0xefefef })
        )

        lhb_batters_box_mesh.position.x = 8.5 / 12 + 6 / 12
        lhb_batters_box_mesh.position.y = -2.8

        this.group.add(lhb_batters_box_mesh)

        const rhb_batters_box_mesh = new THREE.Mesh(
            batters_box_geometry,
            new THREE.MeshBasicMaterial({ color: 0xefefef })
        )

        rhb_batters_box_mesh.position.x = -8.5 / 12 - 6 / 12 - box_width
        rhb_batters_box_mesh.position.y = -2.8

        this.group.add(rhb_batters_box_mesh)
    }
}
